import { extractDataFromResponse, useErrorReporter } from '@mdlinx/frontend-shared';
import { Auth } from '@mdlinx/shared';
import { LogoutResult, useLogoutMutation } from 'generated/client';
import { useEffect } from 'react';
import { trackEvent, getLocationDetails } from '../../lib/analytics';
import { useLocation } from 'react-router-dom';

function sendMessage(message: Auth.LogoutResult) {
  if (window.parent) {
    window.parent.postMessage(message, '*');
  }
}

export const Logout: React.FC = () => {
  const reporter = useErrorReporter();
  const [logout] = useLogoutMutation();
  const location = useLocation();

  useEffect(() => {
    logout()
      .then(extractDataFromResponse)
      .then(
        ({ logout }) => {
          switch (logout) {
            case LogoutResult.Succeeded:
              trackEvent('auth_logout_succeeded', { ...getLocationDetails(location.pathname, location.search) });
              sendMessage(Auth.logoutSucceeded);
              return;
          }
        },
        e => {
          trackEvent('auth_logout_failed', { ...getLocationDetails(location.pathname, location.search) });
          reporter.report(e);
          sendMessage(Auth.logoutFailed);
        },
      );
    return () => {};
  }, [logout, reporter]);
  return null;
};
